module.exports = __webpack_public_path__ + "img/primary.06b49a64.png";